import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mk-not-found',
  templateUrl: './mk-not-found.component.html',
  styleUrls: ['./mk-not-found.component.scss']
})
export class MkNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
